import { MessageSquare, MessageCircle, Info, Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { CancelOrder, CancelOrderAction } from "@/types/order-type";

export function CancelOrderCard({ log }: { log: CancelOrder }) {
    // Map actions to specific icons and colors
    const actionConfig = {
        [CancelOrderAction.Message]: {
            icon: <MessageSquare className="h-4 w-4" />,
            color: "text-blue-600 bg-blue-50 border-blue-100",
            label: "Direct Message"
        },
        [CancelOrderAction.Comment]: {
            icon: <MessageCircle className="h-4 w-4" />,
            color: "text-amber-600 bg-amber-50 border-amber-100",
            label: "Internal Comment"
        },
        [CancelOrderAction.None]: {
            icon: <Info className="h-4 w-4" />,
            color: "text-slate-600 bg-slate-50 border-slate-100",
            label: "System Note"
        }
    };

    const config = actionConfig[log.lastAction];

    return (
        <div className="flex gap-3 relative pb-6 last:pb-0">
            {/* Timeline Line */}
            <div className="absolute left-[15px] top-8 bottom-0 w-px bg-slate-100 last:hidden" />

            {/* Action Icon */}
            <div className={cn("z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border shadow-sm", config.color)}>
                {config.icon}
            </div>

            {/* Content Card */}
            <div className="flex-1 min-w-0 rounded-lg border border-slate-100 bg-white p-3 shadow-sm hover:border-slate-200 transition-colors">
                <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-semibold text-slate-900">{config.label}</span>
                    <span className="flex items-center gap-1 text-[10px] text-slate-400 font-medium whitespace-nowrap">
                        <Clock className="h-3 w-3" />
                        {new Date(log.timestamp).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
                    </span>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed break-words whitespace-pre-wrap">
                    {log.lastContent || <span className="italic text-slate-400">No content provided</span>}
                </p>
            </div>
        </div>
    );
}